<template>
  <section>
    <v-toolbar flat class="main-header px-0 mb-6">
      <v-toolbar-title class="main-header__title">
        <h2 class="heading-counter my-6">
          <span class="counter">5</span>Bus Stops
        </h2>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items class="main-header__contents">
        <v-btn
          class="button btn-height--1 my-auto mx-1"
          @click="addBusStop"
          color="success"
          rounded
          :disabled="addBusCheck()"
        >
          <i class="icon-add-location"></i>
          <span class="mx-2">Add Bus Stop</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <!-- <h2 class="heading-counter my-6">
      <span class="counter">5</span>Bus Stops
    </h2> -->
    <v-card class="global-card px-5 mt-10">
      <v-card-text>
        <v-row>
          <v-col sm="8" cols="12">
            <v-select
              :items="bus_locations"
              item-text="start_point"
              item-value="id"
              regular
              label="Bus Location"
              clearable
              @change="busStopsLocations()"
              v-model="buses.id"
              :disabled="!form.has_bus"
            ></v-select>
          </v-col>
          <v-col sm="4" cols="12">
            <section class="increment-label">
              <span>Capacity</span>
              <number-input
                center
                v-model="buses.capacity"
                :min="14"
                controls
                :disabled="!form.has_bus"
              ></number-input>
            </section>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="bus_headers"
              :items="bus_locations_added"
              hide-default-footer
              :mobile-breakpoint="0"
              :items-per-page="20"
              class="table"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-sm-center">
                    <span>{{ item.start_point }}</span>
                  </td>
                  <td class="text-sm-center">{{ item.capacity }}</td>
                  <td class="text-sm-center">
                    <v-chip
                      outlined
                      color="accent"
                      v-for="bus_stop in item.bus_stops"
                      :key="bus_stop.index"
                    >
                      {{
                        bus_stop.stop_point_name +
                          " " +
                          bus_stop.stop_time +
                          " " +
                          bus_stop.return_time
                      }}
                    </v-chip>
                  </td>
                  <td class="text-sm-center">
                    <i
                      class="icon-delete delete"
                      @click="handleDelete(item)"
                    ></i>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import {
  IndexData
  // StoreData,
  // ShowData,
  // UpdateData
} from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";

export default {
  props: {
    buses: {
      type: Object,
      default: () => {}
    },
    form: {
      type: Object,
      default: () => {}
    },
    busItems: {
      type: Array,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bus_locations: [],
      bus_headers: [],
      bus_locations_added: []
    };
  },
  created() {
    this.indexBusLocations();
    this.createTableHeaders();
  },
  computed: {
    busStops() {
      const type = this.buses.id;
      let bus_locations_data = [];
      this.bus_locations.find(item => {
        if (item.id === type) {
          bus_locations_data = item.bus_stops;
        }
      });
      return bus_locations_data;
    }
  },
  methods: {
    indexBusLocations() {
      IndexData({ reqName: "bus-locations" })
        .then(res => {
          const { data } = res.data;
          this.bus_locations = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = ["Bus Location", "Capacity", "Bus Stops", "Discard"];
      this.bus_headers = TableHeaders(headersList);
    },
    busStopsLocations() {
      const bus_location = this.buses.id;
      this.bus_locations.forEach(item => {
        if (item.id === bus_location) {
          this.buses.start_point = item.start_point;
          this.buses.bus_stops = item.bus_stops;
          this.buses.capacity = item.capacity;
          console.log(item);
        }
      });
    },
    addBusCheck() {
      if (this.buses.id === null) {
        return true;
      } else {
        return false;
      }
    },
    addBusStop() {
      this.bus_locations_added.push(this.buses);
      this.bus_locations = this.bus_locations.filter(
        item => item.id !== this.buses.id
      );
      this.$emit("handle_bus_data", this.bus_locations_added);
      this.$emit("handle_reset_bus_data");
    },
    handleDelete(item) {
      const index = this.bus_locations_added.indexOf(item);
      this.bus_locations_added.splice(index, 1);
      this.bus_locations.push(item.bus_stops[0].bus_location);
    }
  },
  watch: {
    busItems: {
      handler(val) {
        this.bus_locations_added = val;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
